module.exports = __webpack_public_path__ + "img/ja_logo.80818816.svg";